/**
 * Extract DRF-style field errors from a response payload.
 *
 * Returns `{ fieldName: ['msg1', 'msg2'], ... }` for any object whose values
 * are arrays of strings or single strings. Reserved keys (`detail`, `code`,
 * `context`) are skipped — they belong to top-level DRF error envelopes, not
 * to per-field validation messages.
 *
 * Lives in `utils/` (not `services/`) so importing it does NOT pull in the
 * axios httpClient → router → store side-effect chain. The user-facing
 * support module re-exports this for back-compat.
 */
export const extractFieldErrors = (data: unknown): Record<string, string[]> => {
    if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        return {};
    }
    const result: Record<string, string[]> = {};
    for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
        if (key === 'detail' || key === 'code' || key === 'context') {
            continue;
        }
        if (Array.isArray(value)) {
            result[key] = value.map((item) => String(item));
        } else if (typeof value === 'string') {
            result[key] = [value];
        }
    }
    return result;
};
